import * as ErrorMessages from './errorMessages';

export const required = (text) => {
    return text ? null : ErrorMessages.isRequired;
};

export const mustMatch = (field, fieldName) => {
    return (text, state) => {
        return state[field] === text ? null : ErrorMessages.mustMatch(fieldName);
    };
};

export const minLength = (length) => {
    return (text) => {
        return text.length >= length ? null : ErrorMessages.minLength(length);
    };
};

export const maxLength = (length) => {
    return (text) => {
        return text.length <= length ? null : ErrorMessages.maxLength(length);
    };
};

export const email = (field, fieldName) => {
    let reg = /^\w+@\w+\.\w{2,}$/;
    return reg.test(field) ? null : ErrorMessages.emailMatch(fieldName);
};

export const alpha = (field, fieldName) => {
    let reg = /^[а-я\w\s]*$/i;
    return reg.test(field) ? null : ErrorMessages.alphaMatch(fieldName);
};




// WEBPACK FOOTER //
// ./src/validation/rules.js